import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { IGame } from '@core/interfaces/game.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GameService {
  private readonly http = inject(HttpClient);

  public checkGameName(gameName: string): Observable<IGame> {
    return this.http.get<IGame>(`/games/check-game-name/${gameName}`);
  }

  public getGames(params?: HttpParams): Observable<IApiResponse<IGame[]>> {
    return this.http.get<IApiResponse<IGame[]>>('games', { params });
  }
}
